import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';

export const GetEngagementDocuments = createAsyncThunk(
    'timeline/getEngagemetDocuments',
    async (
        arg: {
            timelineId: number;
            sectionId: string;
            filterParams: TableFilter;
        },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(arg.filterParams);
        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${arg.timelineId}/${arg.sectionId}/documents?${queryString}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Engagement documents at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch Engagement ');
            }

            return {
                sectionId: arg.sectionId,
                engagementDocuments: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching Engagements.',
                'error'
            );
            throw error;
        }
    }
);
